document.addEventListener('DOMContentLoaded', () => {
  const isRTL = () => document.documentElement.getAttribute('dir') === 'rtl';

  /** Semantic scroll: negative = toward previous/start, positive = toward next/end */
  const scrollTrack = (track, semanticDirection, factor = 0.82) => {
    if (!track) return;
    const amount = Math.max(track.clientWidth * factor, 320);
    const delta = semanticDirection * amount;
    track.scrollBy({ left: isRTL() ? -delta : delta, behavior: 'smooth' });
  };

  const sizeCount = (node) => Number(node?.dataset?.gxSizeCount || node?.querySelector?.('[data-gx-size-count]')?.dataset?.gxSizeCount || 0);

  const sortByAvailableSizes = (container) => {
    if (!container) return;
    const items = [...container.children];
    if (items.length < 2) return;
    items
      .sort((a, b) => sizeCount(b) - sizeCount(a))
      .forEach((item) => container.append(item));
  };

  document.querySelectorAll('[data-product-track], [data-gx-collection-grid], [data-gx-related-track]').forEach(sortByAvailableSizes);

  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-product-track]');
    carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => {
      scrollTrack(track, -1, 0.82);
    });
    carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => {
      scrollTrack(track, 1, 0.82);
    });
  });
});
